'use strict';

import angular from 'angular';
import grid from 'angular-ui-grid';

import productMovements from '../product-movements/product-movements.component';
import productBarcodes from '../product-barcodes/product-barcodes.component';
import productStorages from '../product-storages/product-storages.component';
import productIncome from '../product-income/product-income.component';
import productOutcome from '../product-outcome/product-outcome.component';
import product from '../product/product.component';
import categoryFilters from '../../components/filters/category';

export class ProductDashboardController {

  addWindow: Function;
  editProductKit: Function;
  getStorages: Function;
  getBarcodes: Function;

  data;
  product;

  productOptions;
  productSelected;
  productGrid;

  /*@ngInject*/
  constructor($scope, $rootScope, Storage, WindowService, $q, AlertMessageFactory) {
    this.Storage  = Storage;
    this.scope    = $scope;
    this.Promise  = $q.defer;

    this.addWindow       = WindowService.addItem;

    this.scope.editProductKit = this.editProductKit.bind(this);
    this.scope.getStorages    = this.getStorages.bind(this);
    this.scope.getBarcodes    = this.getBarcodes.bind(this);

    this.error    = AlertMessageFactory.error;
    this.success  = AlertMessageFactory.success;

    $rootScope.$on('storage.save.product', (product) => this.updateProducts());
  }

  $onInit() {

    this.Storage.onUpdate('product', (product, event) => {
      this.updateProducts();
    });

    this.data.onCategoryChange = () => this.updateProducts();

    this.productOptions = {
      primaryKey: '_id',
      enableCellEdit: true,
      enableRowSelection: true,
      enableRowHeaderSelection: false,
      multiSelect: false,
      modifierKeysToMultiSelect: false,
      noUnselect: true,
      rowEditWaitInterval: -1,
      data: [],
      onRegisterApi: (gridApi) => {
        this.productGrid = gridApi;

        this.productGrid.selection.on.rowSelectionChanged(this.scope, (row) => {
          this.productSelected = undefined;

          if(row.isSelected){
            this.productSelected = row.entity;
          }
        });
        
        this.productGrid.edit.on.afterCellEdit(this.scope, (rowEntity, colDef, newValue, oldValue) => {
          
          if(oldValue  == newValue) {
            return false;
          }

          return this.Storage.saveProduct(rowEntity)
            .then(() => {
              this.productGrid.rowEdit.setRowsClean([rowEntity]);
              this.updateProducts();
            });
        });
      },
      columnDefs: [{
        displayName: '#',
        field: '_id',
        groupable: false,
        resizable: false,
        sortable: false,
        visible: false,
        width: 50
      }, {
        displayName: 'Наименование',
        field: 'name',
        groupable: false,
        resizable: true,
        sortable: true,
        visible: true,
        width: 300
      }, {
        displayName: 'Категория',
        field: 'categoryId',
        groupable: true,
        resizable: true,
        sortable: true,
        visible: true,
        width: 200,
        cellTemplate: '<div class="ui-grid-cell-contents" ng-bind-html="grid.getCellValue(row, col) | renderCategory"></div>',
        editableCellTemplate: 'ui-grid/dropdownEditor',
        editDropdownValueLabel: 'name',
        //editDropdownOptionsArray: this.buildCategorOptions(this.categories),
      }, {
        displayName: 'Цена',
        field: 'amount',
        width: 70,
        type: 'number', 
        cellTemplate: '<span style="padding:5px;">{{row.entity.amount | currency}}</span>',
        cellEditableCondition: (scope) => {
          var subItems = scope.row.entity.kit || [];
          
          if(subItems.length > 0) {
            this.error("Материал является составным из прочих материалов. Если нужно изменить стоимость, добавьте материалы или услуги.");
          }

          return subItems.length == 0;
        },
      }, {
        displayName: 'Цена (Монтаж)',
        field: 'amountWorker',
        width: 70,
        type: 'number', 
        cellTemplate: '<span style="padding:5px;">{{row.entity.amountWorker | currency}}</span>',
        cellEditableCondition: (scope) => {
          var subItems = scope.row.entity.kit || [];
          
          if(subItems.length > 0) {
            this.error("Материал является составным из прочих материалов. Если нужно изменить стоимость, добавьте материалы или услуги.");
          }

          return subItems.length == 0;
        },
      }, {
        displayName: 'Подсчет',
        field: 'countable',
        width: 50,
        type: 'boolean', 
        cellTemplate: '<span style="padding:5px;">{{row.entity.countable ? "Да" : ""}}</span>',
      }, {
        displayName: 'Остаток',
        field: 'available',
        groupable: false,
        resizable: false,
        sortable: false,
        visible: true,
        width: 120,
        cellEditableCondition: function(){ return false; }
      }, {
        displayName: '#',
        name: ' ',
        cellTemplate: '<div>' + 
          '<button ng-click="grid.appScope.editProductKit(row.entity);$event.stopPropagation();""><i class="fa fa-pencil"></i></button>' + 
          '<button ng-click="grid.appScope.getStorages(row.entity);$event.stopPropagation();""><i class="fa fa-database"></i></button>' + 
          '<button ng-click="grid.appScope.getBarcodes(row.entity);$event.stopPropagation();""><i class="fa fa-barcode"></i></button>' + 
          '</div>'
      }]
    };
  }

  buildCategorOptions(categories) {
    return categories.map(c => {
      var pad = '';
      for(var i = 0; i < c.realLelev; i++){
        pad += String.fromCharCode(160) + String.fromCharCode(160);
      }

      return {
        id: c._id,
        name: pad + c.name
      };
    });
  }

  getStorages(product) {
    this.addWindow({
      id: 'product-storages-window',
      component: 'product-storages',
      title: 'Места хранения',
      width: 700,
      height: 530,
      product: product
    });
  }

  getBarcodes(product) {
    this.addWindow({
      id: 'product-barcodes-window',
      component: 'product-barcodes',
      title: 'Штрихкоды',
      width: 700,
      height: 530,
      product: product
    });
  }

  updateProducts() {
    while(this.productOptions.data.length > 0){
      this.productOptions.data.shift();
    }

    this.Storage.getProducts()
      .filter(product => (this.data.categorySelected ? this.data.categorySelected._id : undefined) == product.categoryId)
      .forEach(product => this.productOptions.data.push(product));
  }

  editProductKit(product) {
    this.addWindow({
      id: 'edit-product-window',
      component: 'product',
      title: 'Редактирование документа',
      width: 700,
      height: 530,
      product: product
    });
  }
}



export default angular.module('storageApp.product-dashboard', [
    grid,
    grid + '.selection',
    grid + '.edit',
    grid + '.rowEdit',
    grid + '.saveState',
    grid + '.grouping',

    productMovements,
    productBarcodes,
    productStorages,
    productIncome,
    productOutcome,
    product,

    categoryFilters,
  ])
  .component('productDashboard', {
    bindings: {data: '='},
    template: require('./product-dashboard.html'),
    transclude: true,
    controller: ProductDashboardController
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/product-dashboard/product-dashboard.component.js